import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab,
    IconButton,
    InputAdornment,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip
} from "@mui/material";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import ReorderIcon from "@mui/icons-material/Reorder";
import GTranslateIcon from '@mui/icons-material/GTranslate';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import CampaignIcon from '@mui/icons-material/Campaign';

import {
    add_cluster_data_row,
    change_cluster_data_row_order,
    get_cluster_data,
    get_clusters,
    listen,
    remove_cluster_data_row,
    translate_cluster_cell,
    update_cluster_data_row_cell
} from "../actions/clusters";
import ButtonBase from "@mui/material/ButtonBase";
import {set_page_title} from "../actions/navigation";
import LinearProgress from "@mui/material/LinearProgress";
import TestConfigDialog from "./Dialogs/TestConfigDialog";
import {open_test_dialog, TEST} from "../actions/test";
import MuiAlert from "@mui/lab/Alert";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PsychologyIcon from "@mui/icons-material/Psychology";
import AIImportDialog from "./Dialogs/AIImportDialog";
import CircularProgress from "@mui/material/CircularProgress";
import google_listenable_languages from "../utilities/google_listenable_languages.json";
import {refresh_voice_availability} from "../actions/auth";

const styles = {
    root: {
        marginTop: 15,
        marginLeft: 15,
        marginRight: 15,
        minHeight: "calc(100vh - 86px)",
        position: "relative"
    },
    editCell: {
        width: "100%",
        display: 'block',
        padding: "15px"
    },
    editInput: {
        //width: "initial"
    },
    td: {
        padding: 0
    },
    table: {
        marginBottom: "30px"
    },
    fab: {
        position: 'fixed',
        bottom: "70px",
        right: "10px",
    },
    fab2: {
        position: 'fixed',
        bottom: "150px",
        right: "10px",
    },
    snackbarClose: {
        marginLeft: 15
    },
    link: {
        cursor: "pointer"
    }
};

class Cluster extends Component {

    constructor(props) {
        super(props);
        this.state = {
            edit: {
                row_id: null,
                col: null,
                text: ""
            },
            add: {
                col_1_value: "",
                col_2_value: "",
                col_3_value: "",
                col_1_valueTouched: false,
                col_2_valueTouched: false,
                col_3_valueTouched: false
            },
            error: {
                open: false,
                message: ""
            },
            removePrompt: null,
            aiImportOpen: false,
            speech: {
                state: "stopped",
                row_id: null,
                col_number: null
            }
        };
        this.audio = null;
        this.cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        if (!this.props.clusters) {
            this.props.get_clusters();
        }
        this.props.get_cluster_data(parseInt(this.props.match.params.cluster_id));
    }

    componentWillUnmount() {
        if (this.audio !== null) {
            this.audio.pause();
            this.audio = null;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (parseInt(this.props.match.params.cluster_id) !== parseInt(prevProps.match.params.cluster_id)) {
            this.props.get_cluster_data(parseInt(this.props.match.params.cluster_id));
        }
    }

    handleDragEnd(e) {
        if (e.source && e.destination) {
            const rows = this.props.cluster_rows[parseInt(this.props.match.params.cluster_id)];
            this.props.change_cluster_data_row_order(parseInt(this.props.match.params.cluster_id), rows[e.source.index], rows[e.destination.index]);
        }
    }

    editCell(row_id, col, text) {
        if (this.state.edit.row_id) {
            this.saveEdit();
        }
        this.setState({
            ...this.state,
            edit: {
                row_id: row_id,
                col: col,
                text: text
            }
        });
    }

    removeRow(row_id) {
        this.setState({
            ...this.state,
            removePrompt: row_id
        });
    }

    translateRow(row) {
        const info = this.props.clusters.find(cluster => cluster.id === parseInt(row.cluster_id));
        let translatable = [];
        if (info.col_1_language !== null) translatable.push("col_1_value");
        if (info.col_2_language !== null) translatable.push("col_2_value");
        if (info.col_3_language !== null) translatable.push("col_3_value");
        let targets = [];
        if (info.col_2_name !== null) targets.push("col_2_value");
        if (info.col_3_name !== null) targets.push("col_3_value");
        if (translatable.length > 1) {
            targets.forEach(col => {
                this.translate("col_1_value", col, row["col_1_value"], translated_text => {
                    this.props.update_cluster_data_row_cell(row.cluster_id, row.id, col.replace(/\D/g, ''), translated_text);
                    //console.log(first_not_empty, col, translated_text);
                });
            });
            //console.log(first_not_empty, targets);
        }
    }

    translateAll() {
        const data = this.props.cluster_rows[parseInt(this.props.match.params.cluster_id)];
        const info = this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id));
        let translatable = [];
        if (info.col_1_language !== null) translatable.push("col_1_value");
        if (info.col_2_language !== null) translatable.push("col_2_value");
        if (info.col_3_language !== null) translatable.push("col_3_value");
        let targets = [];
        if (info.col_2_name !== null) targets.push("col_2_value");
        if (info.col_3_name !== null) targets.push("col_3_value");
        if (translatable.length > 1) {
            data.forEach(row => {
                targets.forEach(col => {
                    this.translate("col_1_value", col, row["col_1_value"], translated_text => {
                        this.props.update_cluster_data_row_cell(row.cluster_id, row.id, col.replace(/\D/g, ''), translated_text);
                    });
                });

            });
        }
    }

    remove_agree() {
        this.props.remove_cluster_data_row(parseInt(this.props.match.params.cluster_id), this.state.removePrompt);
        this.remove_close();
    }

    remove_close() {
        this.setState({
            ...this.state,
            removePrompt: null
        });
    }

    saveEditForm(e) {
        e.preventDefault();

        this.saveEdit();
    }

    saveCreateForm(e) {
        e.preventDefault();
        const info = this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id));
        if (this.isAddColInvalid(1, true) && info.col_1_language !== null) {
            if (this.state.add["col_2_value"].trim().length > 0 || this.state.add["col_3_value"].trim().length > 0) {
                let valid_col_number;
                if (this.state.add["col_2_value"].trim().length > 0 && info.col_2_language !== null) {
                    valid_col_number = 2;
                } else if (this.state.add["col_3_value"].trim().length > 0 && info.col_3_language !== null) {
                    valid_col_number = 3;
                } else {
                    valid_col_number = false;
                }
                if (valid_col_number !== false) {
                    this.translate("col_" + valid_col_number + "_value", "col_1_value", this.state.add["col_" + valid_col_number + "_value"], translated_text => {
                        this.setState({
                            ...this.state,
                            add: {
                                ...this.state.add,
                                ["col_1_value"]: translated_text,
                                ["col_1_valueTouched"]: true
                            }
                        }, () => {
                            this.addRow();
                        });
                    });
                } else {
                    this.addRow();
                }
            } else {
                this.addRow();
            }
        } else {
            this.addRow();
        }
    }

    saveEdit() {
        if (this.isEditInvalid()) return;
        let text = this.state.edit.text;
        if (!text) text = "";
        else text = text.trim();
        this.props.update_cluster_data_row_cell(parseInt(this.props.match.params.cluster_id), this.state.edit.row_id, this.state.edit.col, text);

        this.setState({
            ...this.state,
            edit: {
                row_id: null,
                col: null,
                text: ""
            }
        });
    }

    addRow() {
        // cancel edit
        if (!this.isAddValid()) {
            this.setState({
                ...this.state,
                add: {
                    ...this.state.add,
                    col_1_valueTouched: true,
                    col_2_valueTouched: true,
                    col_3_valueTouched: true
                },
                edit: {
                    row_id: null,
                    col: null,
                    text: ""
                }
            });
            return;
        }
        this.props.add_cluster_data_row(parseInt(this.props.match.params.cluster_id), this.state.add.col_1_value.trim(), this.state.add.col_2_value.trim(), this.state.add.col_3_value.trim(), row => {
            this.translateRow(row);
        })
            .catch(err => {
                this.setState({
                    ...this.state,
                    error: {
                        open: true,
                        message: err.response.data.error
                    }
                });
            });
        this.setState({
            ...this.state,
            add: {
                col_1_value: "",
                col_2_value: "",
                col_3_value: "",
                col_1_valueTouched: false,
                col_2_valueTouched: false,
                col_3_valueTouched: false
            },
            edit: {
                row_id: null,
                col: null,
                text: ""
            }
        });
    }

    onEditChange = e => this.setState({
        ...this.state,
        edit: {
            ...this.state.edit,
            text: e.target.value
        }
    });

    translate(source_col, target_col, text, callback) {
        const source_col_number = source_col.replace(/\D/g, '');
        const target_col_number = target_col.replace(/\D/g, '');
        this.props.translate_cluster_cell(parseInt(this.props.match.params.cluster_id), source_col_number, target_col_number, text).then(res => {
            callback(res.data.translated_text);
        });
        //console.log(source_col_number, target_col_number);
    }

    onAddFocus(e) {
        /*if (this.focused_before && this.state.add[this.focused_before].trim().length > 0) {
            console.log("translate by ", this.focused_before);
            console.log("text ", this.state.add[this.focused_before]);
            ["col_1_value", "col_2_value", "col_3_value"].forEach(col => {
                if (this.focused_before === col || this.state.add[col].length > 0) {

                } else {
                    this.translate(this.focused_before, col);
                    console.log("to", col);
                }
            });
        }
        //console.log("focus", e.target.name, e.target.value);
        this.focused_before = e.target.name;*/
    }

    onAddBlur(e) {
        if (this.state.add[e.target.name].trim().length > 0) {
            const info = this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id));
            let translatable = [];
            if (info.col_1_language !== null) translatable.push("col_1_value");
            if (info.col_2_language !== null) translatable.push("col_2_value");
            if (info.col_3_language !== null) translatable.push("col_3_value");
            if (translatable.length > 1) {
                translatable.forEach(col => {
                    if (!(e.target.name === col || this.state.add[col].length > 0)) {
                        this.translate(e.target.name, col, this.state.add[e.target.name], translated_text => {
                            this.setState({
                                ...this.state,
                                add: {
                                    ...this.state.add,
                                    [col]: translated_text,
                                    [col + "Touched"]: true
                                }
                            });
                        });
                    }
                });
            }
        }
    }

    onAddChange(e) {
        //console.log("change", e.target.name, e.target.value);
        this.setState({
            ...this.state,
            add: {
                ...this.state.add,
                [e.target.name]: e.target.value,
                [e.target.name + "Touched"]: true
            }
        });
    }

    isEditInvalid() {
        if (this.state.edit.col > 1) return false; // col 2 a 3 nekontrolujem
        if (this.state.edit.text === null || this.state.edit.text.trim().length < 1) return "Cell must be at least 1 character long.";
        return false;
    }

    isAddColInvalid(col_number, ignoreTouch = false) {
        if (col_number > 1) return false; // col 2 a 3 nekontrolujem
        if (!ignoreTouch && !this.state.add["col_" + col_number + "_value" + "Touched"]) return false;
        if (this.state.add["col_" + col_number + "_value"].trim().length < 1) return "Cell must be at least 1 character long.";
        return false;
    }

    isAddValid() {
        return !this.isAddColInvalid(1, true) && !this.isAddColInvalid(2, true) && !this.isAddColInvalid(3, true);
    }


    handleErrorClose() {
        this.setState({
            ...this.state,
            error: {
                open: false,
                message: ""
            }
        });
    }


    openAiImportDialog() {
        this.setState({
            ...this.state,
            aiImportOpen: true,
        });
    }

    closeDialogs() {
        this.setState({
            ...this.state,
            aiImportOpen: false,
        });
    }

    listen(row_id, col_number) {
        if (this.state.speech.state === "loading") {
            this.cancelToken.cancel("Loading interrupted");
            this.cancelToken = axios.CancelToken.source()
        }

        if (this.audio !== null) {
            this.audio.pause();
            this.audio = null;
        }

        this.setState({
            ...this.state,
            speech: {
                state: "loading",
                row_id,
                col_number
            }
        });

        const cluster_id = parseInt(this.props.match.params.cluster_id);
        this.props.listen(cluster_id, row_id, col_number, this.cancelToken)
            .then((res) => {

                this.setState({
                    ...this.state,
                    speech: {
                        state: "playing",
                        row_id,
                        col_number
                    }
                });

                this.audio = new Audio(URL.createObjectURL(res.data));
                this.audio.currentTime = 0;
                this.audio.play();
                this.audio.onended = () => {
                    this.setState({
                        ...this.state,
                        speech: {
                            state: "stopped",
                            row_id: null,
                            col_number: null
                        }
                    });
                }

            });
        this.props.refresh_voice_availability();
    }

    stop_listen() {
        if (this.audio !== null) {
            this.audio.pause();
            this.audio = null;
        }

        this.setState({
            ...this.state,
            speech: {
                state: "stopped",
                row_id: null,
                col_number: null
            }
        });
    }

    render() {
        if ((this.props.test.state === TEST.RUNNING || this.props.test.state === TEST.PAUSED) && this.props.test.cluster_id === parseInt(this.props.match.params.cluster_id)) {
            this.props.history.push('/clusters');
        }

        const data = this.props.cluster_rows[parseInt(this.props.match.params.cluster_id)];
        if (!data || !this.props.clusters) {
            return <LinearProgress/>
        }
        // todo this.props.set_page_title(this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id)).title);

        const info = this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id));
        let translatable = [];
        if (info.col_1_language !== null) translatable.push("col_1_value");
        if (info.col_2_language !== null) translatable.push("col_2_value");
        if (info.col_3_language !== null) translatable.push("col_3_value");

        const {classes} = this.props;
        /*if (this.props.cluster === null) {
            return <LinearProgress/>
        }*/
        /*

                        <colgroup>
                            <col style={{width: "7%"}}/>
                            <col style={{width: "31%"}}/>
                            <col style={{width: "31%"}}/>
                            <col style={{width: "31%"}}/>
                            <col style={{width: "31%"}}/>
                        </colgroup>
         */
        return (
            <div className={classes.root}>
                {this.state.aiImportOpen && <AIImportDialog handleClose={this.closeDialogs.bind(this)}
                                                            cluster_id={parseInt(this.props.match.params.cluster_id)}
                />}
                <Dialog
                    open={Boolean(this.state.removePrompt)}
                    onClose={this.remove_close.bind(this)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle
                        id="alert-dialog-title">{"Are you sure you want to delete this line?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Line will be permanently deleted without the possibility of recovery.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.remove_close.bind(this)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.remove_agree.bind(this)} color="secondary" autoFocus
                                variant="contained">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.error.open}
                    autoHideDuration={5000}
                    onClose={this.handleErrorClose.bind(this)}
                >
                    <MuiAlert elevation={6} variant="filled" severity="error">
                        {this.state.error.message}
                        <IconButton className={classes.snackbarClose} size="small" aria-label="close"
                                    color="inherit"
                                    onClick={this.handleErrorClose.bind(this)}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </MuiAlert>
                </Snackbar>

                <TestConfigDialog/>

                <TableContainer>

                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">&nbsp;</TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>{info.col_1_name}</TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>{info.col_2_name}</TableCell>
                                <TableCell align="center" style={{
                                    fontSize: "1.25rem",
                                    fontWeight: "bold"
                                }}>{info.col_3_name}</TableCell>
                                <TableCell align="right" className={classes.td}>
                                    {false && translatable.length > 1 &&
                                        <Button variant="contained" startIcon={<GTranslateIcon/>} color="primary"
                                                onClick={() => this.translateAll()}>
                                            Translate all
                                        </Button>}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={this.handleDragEnd.bind(this)}>
                            <Droppable droppableId="droppable" direction="vertical">
                                {(droppableProvided) => (
                                    <TableBody
                                        ref={droppableProvided.innerRef}
                                        {...droppableProvided.droppableProps}
                                    >
                                        {data.map((row, index) => {
                                            const contains_empty_cells = row["col_1_value"] === null || row["col_2_value"] === null || row["col_3_value"] === null;
                                            // (row["col_1_value"].trim().length === 0 || row["col_2_value"].trim().length === 0 || row["col_3_value"].trim().length === 0)
                                            return (
                                                <Draggable
                                                    key={row.id}
                                                    draggableId={row.id.toString()}
                                                    index={index}
                                                >
                                                    {(
                                                        draggableProvided,
                                                        snapshot
                                                    ) => {
                                                        return (
                                                            <TableRow
                                                                ref={draggableProvided.innerRef}
                                                                {...draggableProvided.draggableProps}
                                                                style={{
                                                                    ...draggableProvided.draggableProps.style,
                                                                    background: snapshot.isDragging
                                                                        ? "rgba(245,245,245, 0.1)"
                                                                        : "none",
                                                                    display: snapshot.isDragging
                                                                        ? "table"
                                                                        : "table-row",
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                {/* note: `snapshot.isDragging` is useful to style or modify behaviour of dragged cells */}
                                                                <TableCell align="left" className={classes.td}>
                                                                    <div {...draggableProvided.dragHandleProps}>
                                                                        <ReorderIcon/>
                                                                    </div>
                                                                </TableCell>
                                                                {[1, 2, 3].map((col_number, index) => (
                                                                    <TableCell align="center"
                                                                               key={"cell_" + row.id + "_" + index}
                                                                               className={classes.td}>
                                                                        {this.state.edit && this.state.edit.row_id === row.id && this.state.edit.col === col_number &&
                                                                            <form
                                                                                onSubmit={this.saveEditForm.bind(this)}>
                                                                                <TextField variant="standard"
                                                                                           value={this.state.edit.text}
                                                                                           autoFocus
                                                                                           className={classes.editInput}
                                                                                           onChange={this.onEditChange.bind(this)}
                                                                                           InputProps={{
                                                                                               endAdornment: (
                                                                                                   <InputAdornment
                                                                                                       position="end">
                                                                                                       <IconButton
                                                                                                           onClick={this.saveEdit.bind(this)}
                                                                                                           size="large">

                                                                                                           <CheckIcon
                                                                                                               edge="end"
                                                                                                           />
                                                                                                       </IconButton>
                                                                                                   </InputAdornment>
                                                                                               )
                                                                                           }}
                                                                                           helperText={this.isEditInvalid()}
                                                                                           error={Boolean(this.isEditInvalid())}
                                                                                />
                                                                            </form>}
                                                                        {!(this.state.edit && this.state.edit.row_id === row.id && this.state.edit.col === col_number) &&
                                                                            <div style={{display: "inline-flex"}}>
                                                                                <ButtonBase
                                                                                    className={classes.editCell}
                                                                                    onClick={() => {
                                                                                        this.editCell(row.id, col_number, row["col_" + col_number + "_value"])
                                                                                    }}
                                                                                >
                                                                                    {row["col_" + col_number + "_value"]}
                                                                                </ButtonBase>
                                                                                {!(row["col_" + col_number + "_value"] === "" || row["col_" + col_number + "_value"] === null) && info["col_" + col_number + "_language"] in google_listenable_languages &&
                                                                                    <div style={{
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        {this.state.speech.state === "loading" && this.state.speech.row_id === row.id && this.state.speech.col_number === col_number &&
                                                                                            <CircularProgress
                                                                                                color="primary"
                                                                                                size="12px"
                                                                                                style={{
                                                                                                    margin: "0 8px"
                                                                                                }}
                                                                                            />}
                                                                                        {this.state.speech.state === "playing" && this.state.speech.row_id === row.id && this.state.speech.col_number === col_number &&
                                                                                            <IconButton
                                                                                                aria-label="delete"
                                                                                                size="small"
                                                                                                onClick={() => this.stop_listen()}
                                                                                            >
                                                                                                <StopCircleIcon
                                                                                                    fontSize="inherit"/>
                                                                                            </IconButton>}
                                                                                        {!((this.state.speech.state === "playing" || this.state.speech.state === "loading") && this.state.speech.row_id === row.id && this.state.speech.col_number === col_number) &&
                                                                                            <>
                                                                                                {this.props.auth.user.voice_available &&
                                                                                                    <IconButton
                                                                                                        aria-label="delete"
                                                                                                        size="small"
                                                                                                        onClick={() => this.listen(row.id, col_number)}

                                                                                                    >
                                                                                                        <CampaignIcon
                                                                                                            fontSize="inherit"/>
                                                                                                    </IconButton>}
                                                                                                {!this.props.auth.user.voice_available &&
                                                                                                    <Tooltip
                                                                                                        enterTouchDelay={0}
                                                                                                        classes={{tooltip: classes.noMaxWidth}}
                                                                                                        PopperProps={{
                                                                                                            style: {maxWidth: "70vw"}
                                                                                                        }}
                                                                                                        title={
                                                                                                            <Typography>Upgrade
                                                                                                                to <span
                                                                                                                    style={{
                                                                                                                        fontWeight: 900,
                                                                                                                        cursor: "pointer",
                                                                                                                        color: "#00ff00"
                                                                                                                    }}
                                                                                                                    onClick={() => {
                                                                                                                        this.props.history.push('/premium')
                                                                                                                    }}>PREMIUM</span> to
                                                                                                                Turn on
                                                                                                                A. I.
                                                                                                                Teacher
                                                                                                                Voice!</Typography>}
                                                                                                        placement="left"
                                                                                                        interactive>
                                                                                                        <CampaignIcon
                                                                                                            style={{color: "rgba(255, 255, 255, 0.3)"}}
                                                                                                            fontSize="inherit"/>
                                                                                                    </Tooltip>}
                                                                                            </>}
                                                                                    </div>}
                                                                            </div>}
                                                                    </TableCell>)
                                                                )}

                                                                <TableCell align="right" className={classes.td}>
                                                                    {translatable.length > 1 &&
                                                                        <Tooltip
                                                                            title="Click to Automatically Translate Your Manual Edit"
                                                                            placement="left">
                                                                            <IconButton color="primary"
                                                                                        onClick={() => this.translateRow(row)}
                                                                                        size="large">
                                                                                <GTranslateIcon/>
                                                                            </IconButton>
                                                                        </Tooltip>}
                                                                    <IconButton color="primary"
                                                                                onClick={() => this.removeRow(row.id)}
                                                                                size="large">
                                                                        <DeleteIcon/>
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    }}
                                                </Draggable>
                                            );
                                        })}
                                        {droppableProvided.placeholder}

                                        {this.props.auth.user.premium || data.length < 50 ?
                                            <TableRow>
                                                <TableCell align="left" className={classes.td}>
                                                </TableCell>


                                                {[1, 2, 3].map((col_number, index) => (
                                                    <TableCell align="center" key={"add_cell_" + index}
                                                               className={classes.td}>
                                                        <form onSubmit={this.saveCreateForm.bind(this)}>
                                                            <TextField
                                                                variant="standard"
                                                                value={this.state.add["col_" + col_number + "_value"]}
                                                                name={"col_" + col_number + "_value"}
                                                                autoFocus={col_number === 1}
                                                                className={classes.editInput}
                                                                onChange={this.onAddChange.bind(this)}
                                                                onFocus={this.onAddFocus.bind(this)}
                                                                onBlur={this.onAddBlur.bind(this)}
                                                                helperText={this.isAddColInvalid(col_number)}
                                                                error={Boolean(this.isAddColInvalid(col_number))}
                                                                required={col_number === 1}
                                                            />
                                                        </form>
                                                    </TableCell>))}

                                                <TableCell align="right" className={classes.td}>
                                                    <IconButton color="primary" onClick={this.saveCreateForm.bind(this)}
                                                                size="large">
                                                        <CheckIcon/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                            :

                                            <TableRow>
                                                <TableCell colSpan={5} align={"center"}>
                                                    <Typography>Upgrade to <span
                                                        style={{
                                                            fontWeight: 900,
                                                            cursor: "pointer",
                                                            color: "#00ff00"
                                                        }}
                                                        onClick={() => {
                                                            this.props.history.push('/premium')
                                                        }}>PREMIUM</span> with No Limit of Rows!</Typography>
                                                </TableCell>
                                            </TableRow>
                                        }

                                    </TableBody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Table>
                </TableContainer>

                {this.props.auth.user.ai_available && info.shared_by === null &&
                    <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                             PopperProps={{
                                 style: {maxWidth: "70vw"}
                             }}
                             title={<Typography>Ask A. I. Teacher</Typography>}
                             placement="left" interactive>
                        <Fab color="primary" className={classes.fab2}
                             disabled={this.state.aiImportOpen}
                             onClick={this.openAiImportDialog.bind(this)}>
                            <PsychologyIcon/>
                        </Fab>
                    </Tooltip>}
                {(!this.props.auth.user.ai_available || info.shared_by !== null) &&
                    <Tooltip enterTouchDelay={0} classes={{tooltip: classes.noMaxWidth}}
                             PopperProps={{
                                 style: {maxWidth: "70vw"}
                             }}
                             title={<Typography>Upgrade to <span
                                 style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                 onClick={() => {
                                     this.props.history.push('/premium')
                                 }}>PREMIUM</span> to ask A. I. Teacher!</Typography>}
                             placement="left" interactive>
                        <div className={classes.fab2}>
                            <Fab color="primary" disabled={true}>
                                <PsychologyIcon/>
                            </Fab>
                        </div>
                    </Tooltip>}

                <Fab color="primary" aria-label="add" className={classes.fab}
                     disabled={this.props.test.state !== TEST.NOT_RUNNING}
                     onClick={() => this.props.open_test_dialog(info.id)}>
                    <PlayArrowIcon/>
                </Fab>

            </div>
        );
    }
}

const
    mapStateToProps = state => ({
        is_logged: state.auth.is_logged,
        test: state.test,
        auth: state.auth,
        clusters: state.clusters.clusters,
        cluster_rows: state.clusters.cluster_rows
    });


export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {
        open_test_dialog,
        set_page_title,
        change_cluster_data_row_order,
        update_cluster_data_row_cell,
        add_cluster_data_row,
        remove_cluster_data_row,
        get_cluster_data,
        get_clusters,
        translate_cluster_cell,
        listen,
        refresh_voice_availability
    }
)(Cluster)));
